import api from './api';

/**
 * SOW Service
 * Handles SOW (Statement of Work) value management
 */

export const sowService = {
  /**
   * Get all SOW values for a project
   */
  getSOWValuesForProject: async (projectCode) => {
    const response = await api.get(`/sow/project/${projectCode}`);
    return response.data;
  },

  /**
   * Get SOW metrics for a project
   */
  getSOWMetrics: async (projectCode) => {
    const response = await api.get(`/sow/metrics/${projectCode}`);
    return response.data;
  },

  /**
   * Get SOW metrics for all projects
   */
  getAllSOWMetrics: async () => {
    const response = await api.get('/sow/metrics');
    return response.data;
  },

  /**
   * Get single SOW value by ID
   */
  getSOWValueById: async (id) => {
    const response = await api.get(`/sow/${id}`);
    return response.data;
  },

  /**
   * Create new SOW value
   */
  createSOWValue: async (data) => {
    const response = await api.post('/sow', data);
    return response.data;
  },

  /**
   * Update SOW value
   */
  updateSOWValue: async (id, data) => {
    const response = await api.put(`/sow/${id}`, data);
    return response.data;
  },

  /**
   * Delete SOW value
   */
  deleteSOWValue: async (id) => {
    const response = await api.delete(`/sow/${id}`);
    return response.data;
  },

  /**
   * Get monthly burn report for SOW tracking
   * @param {string|null} projectCode - Specific project or null for all accessible projects
   * @param {string} startMonth - Start month in YYYY-MM-DD format
   * @param {string} endMonth - End month in YYYY-MM-DD format
   */
  getMonthlyBurnReport: async (projectCode, startMonth, endMonth) => {
    const params = new URLSearchParams();
    if (projectCode && projectCode !== 'ALL') {
      params.append('project_code', projectCode);
    }
    params.append('start_month', startMonth);
    params.append('end_month', endMonth);
    const response = await api.get(`/sow/monthly-report?${params}`);
    return response.data;
  },
};

export default sowService;
